import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'tr-form-group-content',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './form-group-content.component.html',
  //styleUrls: ['./form-group-content.component.scss']
})
export class FormGroupContentComponent {

  @Input() label: string;

}



// WEBPACK FOOTER //
// ./src/app/shared/components/form/form-group-content/form-group-content.component.ts